// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkAssessmentStatusSchema = z.enum(['DRAFT','DISCOVERING','GENERATING_SIGNALS','EXECUTING','WAITING_FOR_NEXT_SIGNAL','COMPLETED','FAILED','ABORTED'] as const);

export type InternalNetworkAssessmentStatusType = `${z.infer<typeof InternalNetworkAssessmentStatusSchema>}`

export default InternalNetworkAssessmentStatusSchema;
